import { __assign } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import styles from './Info.module.esm.js';

var TooltipCard = function (_a) {
    var arrowRef = _a.arrowRef, className = _a.className, content = _a.content, tooltipRef = _a.tooltipRef, getArrowProps = _a.getArrowProps, getTooltipProps = _a.getTooltipProps, placement = _a.placement;
    return (React.createElement("div", __assign({}, getTooltipProps({ ref: tooltipRef }), { className: classNames(styles.card, className) }),
        React.createElement("div", __assign({}, getArrowProps({
            'data-placement': placement,
            ref: arrowRef,
        }))),
        content));
};

export { TooltipCard as default };
//# sourceMappingURL=TooltipCard.esm.js.map
